import { rei } from "@/services/api"

class RegimeBensService {
  static storeRegimeBens (params) {
    return rei.post(`regime-de-bens`, { ...params })
  }

  static getRegimeBens (params = null) {
    if (params == null) {
      return rei.get(`regime-de-bens`).then(res => res.data)
    } else {
      let query = []
      query.push(params.perPage ? 'perPage=' + params.perPage : '')
      query.push(params.page ? 'page=' + params.page : '')
      query.push(params.ativo ? 'ativo=' + params.ativo : '')
      query.push(params.nome ? 'nome=' + params.nome : '')
      query.push(params.descricao ? 'descricao=' + params.descricao : '')
      query.push(params.complemento ? 'complemento=' + params.complemento : '')
      query.push(params.cartorio_id ? 'cartorio_id=' + params.cartorio_id : '')
      return rei.get(`regime-de-bens?${query.join('&')}`).then(res => res.data)
    }
  }

  static updateRegimeBens (regime, id) {
    return rei.put(`regime-de-bens/${id}`, regime).then(res => res.data)
  }

  static excludeRegimeBens (id) {
    return rei.delete(`regime-de-bens/${id}`)
  }
}

export default RegimeBensService
